angular.module('mychart').controller('ObservationOrderPrintDownloadModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', '$window', 'PersonRepository', 'resultInfo',
        function ($scope, $modalInstance, $sce, $window, PersonRepository, resultInfo) {
            'use strict';

            $scope.resultInfo = resultInfo;

            $scope.loadingLabResult = true;
            $scope.displayPrintButton = false;

            $scope.model = {
                ObservationOrderData: '',
                PdfFileName: resultInfo.ActivePatient.firstName + resultInfo.ActivePatient.lastName + '_ObservationOrder.pdf',
                ByteArray: '',
                ContentType: ''
            };

            function loadResult() {
                $scope.loadingLabResult = true;
                $scope.removeHttpError();
                PersonRepository.getObservationOrderPdf(resultInfo.ActivePatient.id,  resultInfo.ResultId)
                    .then(function (data) {
                        var observationOrderUrl = 'data:' + data.ContentType + ';base64,' + data.ByteArray;
                        $scope.model.ObservationOrderData = $sce.trustAsResourceUrl(observationOrderUrl);
                        $scope.model.ByteArray = data.ByteArray;
                        $scope.model.ContentType = data.ContentType;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function() {
                        $scope.loadingLabResult = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }


            $scope.ok = ok;
            $scope.cancel = cancel;
            $scope.print = print;

            loadResult();
        }]);